import { http } from '../../config/axios'

export default function patchFaturaManualGerarService(id: string): Promise<string> {
  return http
    .patch('/api/fatura/manual/gerar/' + id)
    .then((r) => r.data)
    .catch((error) => {
      console.error('Erro ao processar fatura manual', error)
      throw Error(error.response?.data)
    })
}
